import { action } from 'typesafe-actions';

import { EnterpriseId } from 'types/models/enterprise';
import Notification, { NotificationAcknowledgementType, NotificationId } from 'types/models/notification';
import { SiteId } from 'types/models/site';

import ActionTypes from './constants';

/**
 * @deprecated In favor of loadPaginatedNotifications() and loadRecentUnacknowledgedNotifications() for site-wide
 * alert acknowledgement feature
 */
export const loadRecentNotifications = (enterpriseId: EnterpriseId) =>
  action(ActionTypes.LOAD_RECENT_NOTIFICATIONS_REQUEST, { enterpriseId });

/**
 * @deprecated In favor of loadPaginatedNotificationsSuccess() and loadRecentUnacknowledgedNotificationsSuccess() for
 * site-wide alert acknowledgement feature
 */
export const loadRecentNotificationsSuccess = () => action(ActionTypes.LOAD_RECENT_NOTIFICATIONS_SUCCESS);

/**
 * @deprecated In favor of loadPaginatedNotificationsFailure() and loadRecentUnacknowledgedNotificationsFailure() for
 * site-wide alert acknowledgement feature
 */
export const loadRecentNotificationsFailure = (message: string) =>
  action(ActionTypes.LOAD_RECENT_NOTIFICATIONS_FAILURE, { message }, undefined, true);

export const loadRecentUnacknowledgedNotifications = (enterpriseId: EnterpriseId) =>
  action(ActionTypes.LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_REQUEST, { enterpriseId });

export const loadRecentUnacknowledgedNotificationsSuccess = () =>
  action(ActionTypes.LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_SUCCESS);

export const loadRecentUnacknowledgedNotificationsFailure = (message: string) =>
  action(ActionTypes.LOAD_RECENT_UNACKNOWLEDGED_NOTIFICATIONS_FAILURE, { message }, undefined, true);

export const loadPaginatedNotifications = (
  enterpriseId: EnterpriseId,
  siteId: SiteId,
  currentPage: number | undefined
) => action(ActionTypes.LOAD_PAGINATED_NOTIFICATIONS_REQUEST, { enterpriseId, siteId, currentPage });

export const loadPaginatedNotificationsSuccess = () => action(ActionTypes.LOAD_PAGINATED_NOTIFICATIONS_SUCCESS);

export const loadPaginatedNotificationsFailure = (message: string) =>
  action(ActionTypes.LOAD_PAGINATED_NOTIFICATIONS_FAILURE, { message }, undefined, true);

export const acknowledgeNotification = (
  notificationId: NotificationId,
  acknowledgementType: NotificationAcknowledgementType
) => action(ActionTypes.SET_PENDING_ACKNOWLEDGEMENT, { notificationId, acknowledgementType });

export const acknowledgeNotificationSuccess = () => action(ActionTypes.ACKNOWLEDGE_NOTIFICATION_SUCCESS);

export const acknowledgeNotificationFailure = (message: string) =>
  action(ActionTypes.ACKNOWLEDGE_NOTIFICATION_FAILURE, { message }, undefined, true);

export const removePendingAcknowledgement = (notificationId: NotificationId) =>
  action(ActionTypes.REMOVE_PENDING_ACKNOWLEDGEMENT, { notificationId });

export const setNotification = (notification: Omit<Notification, 'event'>) =>
  action(ActionTypes.SET_NOTIFICATION, notification);

export const bulkAcknowledgeNotifications = (
  notificationIds: NotificationId[],
  onSuccess: (successCount: number, failCount: number) => void,
  onFailure: (message: string) => void
) =>
  action(
    ActionTypes.BULK_ACKNOWLEDGE_NOTIFICATIONS_REQUEST,
    {
      notificationIds,
      onSuccess,
      onFailure
    }
  );

export const bulkAcknowledgeNotificationsSuccess = () => action(ActionTypes.BULK_ACKNOWLEDGE_NOTIFICATIONS_SUCCESS);

export const bulkAcknowledgeNotificationsFailure = (message: string) =>
  action(ActionTypes.BULK_ACKNOWLEDGE_NOTIFICATIONS_FAILURE, { message }, undefined, true);

/**
 * @deprecated In favor of setPaginatedNotifications() and setRecentUnacknowledgedNotifications() for site-wide alert
 * acknowledgement feature
 */
export const setRecentNotifications = (
  enterpriseId: EnterpriseId,
  recentNotifications: Record<NotificationId, Notification>
) =>
  action(ActionTypes.SET_RECENT_NOTIFICATIONS, { enterpriseId, recentNotifications });

export const setPaginatedNotifications = (
  enterpriseId: EnterpriseId,
  notifications: Record<NotificationId, Notification>,
  currentPage: number,
  total: number
) => action(ActionTypes.SET_PAGINATED_NOTIFICATIONS, { enterpriseId, notifications, currentPage, total });

export const setRecentUnacknowledgedNotifications = (
  enterpriseId: EnterpriseId,
  notifications: Record<NotificationId, Notification>
) =>
  action(ActionTypes.SET_RECENT_UNACKNOWLEDGED_NOTIFICATIONS, { enterpriseId, notifications });
